import { useApi, QueryKeys } from "@akina/infra";
import { useQuery } from "@tanstack/react-query";
import { useDeveloperToolsStore } from "./";
import { useLocaleStore } from "./useLocaleStore";

const REFETCH_INTERVAL_IN_MS = 60 * 30 * 1000; // 30 minutes

export const useFetchLocaleCopy = (slugs: string[]) => {
  const { api } = useApi();
  const { locale } = useLocaleStore();
  const { useCmsPreview } = useDeveloperToolsStore();

  return useQuery({
    queryKey: [QueryKeys.fetchLocaleCopy, locale],
    queryFn: async () => {
      await new Promise(resolve => setTimeout(resolve, 250)); // min delay for UX purposes
      return useCmsPreview ? await api.localeCopy.getLocaleCopy(slugs) : await api.localeCopy.getCmsCopy(slugs);
    },
    staleTime: REFETCH_INTERVAL_IN_MS,
    refetchInterval: REFETCH_INTERVAL_IN_MS,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    enabled: !!locale,
  });
};
